import * as React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { accent } from './styled/Theme';

const Container = styled.div`
  display: flex;
  align-items: flex-start;

  .isvg {
    line-height: 0;
    .brandable {
      fill: ${props => accent(props.theme)};
      path {
        fill: ${props => accent(props.theme)};
      }
    }
  }

  .isvg svg {
    width: 50px;
    height: 50px;
  }
`;

type Props = {
  path: string;
  className?: string;
};

const Pictogram = ({ path, className }: Props) => (
  <Container aria-hidden="true" role="presentation">
    <SVG src={path} className={className} />
  </Container>
);
Pictogram.defaultProps = {
  className: undefined,
};

export default Pictogram;
